// extracted by mini-css-extract-plugin
module.exports = {"table":"MyApps_table__1P6-g"};